document.documentElement.classList.add('xsdfr-js');

const revealXsdfrSections = () => {
  const items = document.querySelectorAll('.xsdfr-reveal:not([data-xsdfr-reveal-ready])');
  if (!items.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => {
      item.dataset.xsdfrRevealReady = 'true';
      item.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  items.forEach((item) => {
    item.dataset.xsdfrRevealReady = 'true';
    observer.observe(item);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealXsdfrSections, { once: true });
} else {
  revealXsdfrSections();
}

document.addEventListener('shopify:section:load', revealXsdfrSections);
